module.exports = __webpack_public_path__ + "img/logo-07.53a8deea.png";